import { useModal } from "@/context/ModalContext";
import { useTranslation } from "react-i18next";
import { Button } from "../ui/button";

export default function ModalCompleteRegistration() {
  const { t } = useTranslation();
  const { hideModal } = useModal();

  return (
    <div>
      <div>
        <p className="text-2xl font-medium">
          {t("auth.complete_registration.title")}
        </p>
        <p className="mb-8 text-base text-gray-600 mt-1">
          {t("auth.complete_registration.subtitle")}
        </p>
      </div>
      <div className="flex flex-col">
        <div className="flex flex-row justify-center">
          <Button
            variant={"takyon"}
            type="button"
            onClick={() => {
              hideModal();
            }}
          >
            {t("buttons.close")}
          </Button>
        </div>
      </div>
    </div>
  );
}
